export class ProductResponse {
	active: boolean;
	addcost: boolean;
	barCode: string;
	bought: boolean;
	canEdit: boolean;
	category: number;
	code: string;
	company: number;
	compound: boolean;
	consumptionFactor: any;
	creationDate: number;
	description: string;
	exemptTextId: any;
	expenseType: any;
	extraTaxId: any;
	finishedProductPercentage: any;
	hasExtraTax: boolean;
	id: number;
	idAssociated: any;
	image: any;
	isExempt: boolean;
	measurement: number;
	metaProductId: any;
	name: string;
	notAssociated: boolean;
	parentCategory: number;
	parentProduct: any;
	productType: string;
	provisionalPercentage: any;
	saleCostPercentage: any;
	sold: boolean;
	type: string;
	virtual: boolean;
	units!: number;
	calc!: string;
	existences!: number;
	associates!: any;

	constructor() {

	}
}

export class ProductRequest {
	barCode: string;
	bought: boolean;
	category: string;
	code: string;
	description: string;
	exemptTextId: string;
	extraTaxId: string;
	extraTaxTypeId: string = "";
	hasExtraTax: boolean;
	canBeExent: boolean;
	idAssociated: string;
	image: string;
	isExempt: boolean;
	measurement: string;
	measurementCategory: string;
	name: string;
	parentCategory: string;
	priceList: [];
	productId: any;
	productName: string;
	productPrice: any;
	productType: string;
	sold: boolean;
	notAssociated = true;
	type: string = 'b';
	virtual?: boolean = false;
	addcost?: boolean = false;
	constructor() {

	}
}

export class TransformationProduct {
	addCost?: boolean = false;
	isVirtual?: boolean = false;
	expectedDate: number;
	fromProducts: TransformationProductItem[] = [];
	fromWarehouse: number;
	fromWarehouseName: string;
	instantProcess: boolean = true;
	issuedDate: number;
	toProducts: any[] = [];
	toWarehouse: number;
	toWarehouseName: string;
	transformation?: boolean = false;
	description: string = "";
	plate: string;
	carrier: any;
}

export class TransformationProductItem {
	costPercentage: number;
	existence: number;
	productId: number;
	productName: string;
	quantity: number;
}

export class ProductHistoryResponse {
	yearMonth: number;
	total_quantity_sold: number;
}

export class CountProductRequest {
	product!: ProductResponse;
	confirmZero: boolean;
	addingComment: boolean;
	id: number;
	units: number;
	comments: string;

	counted: boolean = false;
}

export class PrioritiesInventoryResponse {
	id: number;
	product: ProductResponse;
	warehouse: number;
	showDelete!: boolean;
	deleting!: boolean;
}

export class PrioritiesInventoryRequest {
	warehouse: number;
	products: number[];
}

export class InventoryProductWithoutCostResponse {
	productId: number;
	warehouseId: number;
	productCode: string;
	productBarCode: string;
	productName: string;
	warehouseName: string;
	//for-frontend
	cost!: number;
	loading!: boolean;
}

export interface MeasurementResponse {
	id: number;
	category: number;
	unit: string;
}

export class ProductRoutingResponse {
	id: number;
	name: string;
}

export interface RoutingProductResponse {
	id: number;
	productEntry: ProductResponse;
	productSale: ProductResponse;
	productEntryData: ProductResponse;
	productSaleData: ProductResponse;
}

export interface RoutingProductPurchaseResponse {
    id: number;
    productPurchase: ProductResponse;
    productOC: ProductResponse;
    productPurchaseData: ProductResponse;
    productOCData: ProductResponse;
}

export interface RoutingProductPurchaseRequest {
    productPurchase: number;
    productOC: number;
}